export const mutations = {
    STORE_USERLOGIN_ATTEMPTS(state, userattempts) {
        state.attempts = userattempts
    },
    STORE_CURRENT_USERNAME(state, usrname) {
        state.username = usrname
    },
    STORE_CURRENT_PIC(state, pic) {
        state.profilePic = pic
    },
    STORE_USER_ROLES_MODULES(state, rolemodules) {
        state.usermodules = rolemodules
    }
};
export default mutations


// WEBPACK FOOTER //
// ./src/vuex/modules/auth/mutations.js